/**
 * Gets the hostname (without TLD) from the current hostname, uppercased.
 * If the hostname is localhost or has no TLD, defaults to 'INCOGNINET'
 * 
 * @returns {string} The hostname to use (e.g., 'INCOGNINET' or 'VPN123')
 */
export function getHostname() {
  const hostname = window.location.hostname;
  
  // Handle localhost or IP addresses
  if (hostname === 'localhost' || hostname === '127.0.0.1' || !hostname.includes('.')) {
    return 'INCOGNINET';
  }
  
  // Extract hostname without TLD
  // For 'incogninet.net' -> 'INCOGNINET'
  // For 'vpn123.net' -> 'VPN123'
  // For 'app.incogninet.net' -> 'INCOGNINET' (takes the first part before the domain)
  const parts = hostname.split('.');
  
  // If we have at least 2 parts, take the part before the TLD
  // For subdomains like 'app.vpn111.com', we want 'vpn111', so we take parts[parts.length - 2]
  if (parts.length >= 2) {
    // Get the part before the TLD (second to last part)
    const hostnamePart = parts[parts.length - 2];
    return hostnamePart.toUpperCase();
  }
  
  // Fallback to default
  return 'INCOGNINET';
}
